import type { FaireProductEntity } from "../../entity_types/product";

export const p_phz4ynyscm: FaireProductEntity = {
  token: "p_phz4ynyscm",
  type: "product",
  name: "Toggi 24 Ct 0.88 Oz Fine European Milk Chocolate Wafers",
  brandToken: "b_et6a66kd2z",
  brandName: "Long Island Candy Factory",
  imageUrl:
    "https://cdn.faire.com/fastly/ca03b687757b30e4c57a14ca63f40d420e8599d51660f409bf80680519ad3eb6.jpeg",
  galleryImageUrls: [],
  priceDollars: 34.63,
  description:
    "Indulge in the exquisite taste of Toggi 24 Ct 0.88 Oz Fine European Milk Chocolate Wafers. Crafted from premium European chocolate and boasting a delicate wafer texture, each piece is individually wrapped to preserve its freshness. Elevate your snacking experience with these luxurious chocolate wafers.Long Island Candy Factory is open for in-store shopping at 40 Rabro Drive from 9:00 AM - 4:00 PMFor bulk sales, wholesale, or catering email us at [redacted-email]",
  tags: [],
  msrpDollars: 69.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:06.771Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
